import React, { memo, useCallback } from 'react';
import { DynamicListFilter, FilterProps } from '@dfl/mui-admin-layout';
import { useSearchParams } from 'react-router-dom';

interface CityAddressFilterProps extends FilterProps {
  countryKey?: string;
  stateKey?: string;
  justUseFor?: string;
  hideCity?: boolean;
  multiple?: boolean;
}

const CityAddressFilter = ({
  filter,
  value,
  onChange,
  title,
  countryKey,
  stateKey,
  justUseFor,
  hideCity,
  multiple = false,
}: CityAddressFilterProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const countryCode = searchParams.get(countryKey || 'country') || '';
  const stateCode = searchParams.get(stateKey || 'state') || '';
  const effectiveCountryCode = justUseFor || countryCode;

  const fetchFunc = useCallback(
    async (params?: any) => {
      params = { ...params, country: effectiveCountryCode, state: stateCode };
      return await filter?.fetchFunc?.(params);
    },
    [effectiveCountryCode, filter, stateCode],
  );

  const handleCityChange = useCallback(
    (e: any) => {
      const newSearchParams = new URLSearchParams(searchParams.toString());
      const selected: string[] = Array.isArray(e) ? e : [e].filter(Boolean);

      newSearchParams.delete(filter.key);
      if (selected.length > 0) {
        newSearchParams.set(filter.key, selected.join(','));
      }
      setSearchParams(newSearchParams);
    },
    [searchParams, setSearchParams, filter.key],
  );

  const parsedValue: string[] = multiple
    ? (searchParams.get(filter.key) || '').split(',').filter(Boolean)
    : Array.isArray(value)
      ? value
      : value
        ? [value]
        : [];

  if (effectiveCountryCode !== 'CU' || !stateCode || hideCity) {
    return null;
  }

  return (
    <DynamicListFilter
      key={`${filter.key}-${effectiveCountryCode}-state-${stateCode}-city-${value as string}`}
      // @ts-ignore
      filter={{
        ...filter,
        fetchFunc,
        queryKey: `${filter.key}-${effectiveCountryCode}-state-${stateCode}-city-${value as string}`,
        multiple,
      }}
      value={!effectiveCountryCode && !stateCode ? '' : parsedValue}
      title={title}
      onChange={multiple ? handleCityChange : onChange}
    />
  );
};

export default memo(CityAddressFilter);
